<script setup>

</script>

<template>
<div class="text-3xl text-blue-500">Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex repellendus, voluptatum assumenda libero atque beatae.</div>
</template>
